<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-wight-bg py-16 ">
      <div class="container sec-garay-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="'چشم انداز'"/>
          </h5>
        </div>
      </div>
      <div v-if="isPageLoaded" class="container py-16">
        <div class="row">
          <div class="col-12">
            <v-img class="img-fluid mx-auto" :src="$replaceHttps(PageContent.fileUrl)" height="300"></v-img>
          </div>
        </div>
        <div class="container">
          <div class="row sec-garay-bg">
            <div class="col " v-html="PageContent.description"></div>
          </div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

export default {
  name: "visionPage",
  components: {PageTitle, FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-چشم انداز'
  },
  data: () => ({
    isPageLoaded: false,
    PageContent: null,
    showLoaderDialog: false,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/PageContent?TypePage=5", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.PageContent = JSON.parse(result)
            this.isPageLoaded = true
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>